import axios from 'axios';

import {
  ADDRESS_SEARCH_REQUEST_START,
  ADDRESS_SEARCH_REQUEST_FAIL,
  ADDRESS_SEARCH_REQUEST_SUCCESS,
  ADDRESS_RETRIEVE_REQUEST_START,
  ADDRESS_RETRIEVE_REQUEST_FAIL,
  ADDRESS_RETRIEVE_REQUEST_SUCCESS,
  ADDRESS_SEARCH_CLEAR_ALL
} from './types';

import { getServicesErrorObj }  from '../servicesDowntime/actions';

export const addressSearchRequestStart = (payload: any) => ({
  type: ADDRESS_SEARCH_REQUEST_START,
  payload
});

export const addressSearchRequestFail = (payload: any) => ({
  type: ADDRESS_SEARCH_REQUEST_FAIL,
  payload
});

export const addressSearchRequestSuccess = (payload: any) => ({
  type: ADDRESS_SEARCH_REQUEST_SUCCESS,
  payload
});

export const addressRetrieveRequestStart = (payload: any) => ({
  type: ADDRESS_RETRIEVE_REQUEST_START,
  payload
});

export const addressRetrieveRequestFail = (payload: any) => ({
  type: ADDRESS_RETRIEVE_REQUEST_FAIL,
  payload
});

export const addressRetrieveRequestSuccess = (payload: any) => ({
  type: ADDRESS_RETRIEVE_REQUEST_SUCCESS,
  payload
});

export const clearAddressResults = (payload: any) => ({
  type: ADDRESS_SEARCH_CLEAR_ALL,
  payload
});

const PCA_API_KEY = 'RZ21-CD99-ZF18-CG63'

export const ADDRESS_SEARCH_URL: Function = (
  Text: string,
  Countries: string,
  Limit: number = 10,
  Key: string = PCA_API_KEY
) => `https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.00/json3ex.ws?Key=${Key}&Text=${Text}&Countries=${Countries}&Limit=${Limit}`;

export const ADDITIONAL_ADDRESS_SEARCH_URL: Function = (
  Text: string,
  Countries: string,
  Container: string,
  Limit: number = 10,
  Key: string = PCA_API_KEY
) => `https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.00/json3ex.ws?Key=${Key}&Text=${Text}&Countries=${Countries}&Container=${Container}&Limit=${Limit}`;

export const ADDRESS_RETRIEVE_URL: Function = (
  Id: string,
  Key: string = PCA_API_KEY
) => `https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.00/json3ex.ws?Key=${Key}&Id=${Id}`;

export const additionalAddressSearch = (text: string, country: string, container: string, isJoint: boolean) => (
  dispatch: Function
) => new Promise((resolve, reject) =>{
  dispatch(addressSearchRequestStart({
    isJoint
  }));

  axios.get(ADDITIONAL_ADDRESS_SEARCH_URL(text, country, container)).then((response: any) => {
    dispatch(addressSearchRequestSuccess({
      data: response.data,
      isJoint
    }));
    resolve(response.data);
  }).catch((error: any) => {
    dispatch(addressSearchRequestFail({
      isJoint
    }));
    dispatch(getServicesErrorObj(error));
    reject();
  });
});

export const addressSearch = (text: string, country: string, isJoint: boolean) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(addressSearchRequestStart({
    isJoint
  }));

  axios.get(ADDRESS_SEARCH_URL(text, country)).then((response: any) => {
    dispatch(addressSearchRequestSuccess({
      data: response.data,
      isJoint
    }));
    resolve(response.data);
  }).catch((error: any) => {
    dispatch(addressSearchRequestFail({
      isJoint
    }));
    dispatch(getServicesErrorObj(error));
    reject();
  });
});

export const addressRetrieve = (id: string, isJoint: boolean) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(addressRetrieveRequestStart({
    isJoint
  }));

  axios.get(ADDRESS_RETRIEVE_URL(id)).then((response: any) => {
    dispatch(addressRetrieveRequestSuccess({
      data: response.data,
      isJoint
    }));
    resolve(response.data);
  }).catch((error: any) => {
    dispatch(addressRetrieveRequestFail({
      isJoint
    }));
    dispatch(getServicesErrorObj(error));
    reject();
  });
});

export type AddressSearchAction = {
  type: string,
  payload?: any
};
